import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ExcRestService} from 'exc-rest-v2';
import {ExgModalService} from 'exc-controls-v2';
import {EnumerationService} from '../../../services/enumeration.service';
import {ExcTranslation} from 'exc-core-v2';

@Component({
  selector: 'app-modal-new-task',
  templateUrl: './modal-new-task.component.html',
  styles: []
})
export class ModalNewTaskComponent extends ExcTranslation implements OnInit {

  @Input() data: { auID: any; oeList: any } = {auID: '', oeList: []};

  taskTypeIndex = this.enumSvc.getEnumerationList('VorgangTyp').findIndex(e => e.enmDefault);
  taskStatusDefault = this.enumSvc.getEnumerationList('VorgangStatus').findIndex(e => e.enmDefault);

  taskTypeDefaultObject = this.enumSvc.getEnumerationList('VorgangTyp').find((e) => {
    return e.enmSelector;
  })

  taskTypeList = this.enumSvc.getEnumerationList('VorgangTyp');
  taskTypeText: any = [];
  taskTypeIdent: any = [];
  taskSubTypeText: any = [];
  taskSubTypeIdent: any = [];
  taskSubTypeDefault: any = [];
  taskStatusText: any = [];
  taskStatusIdent: any = [];
  taskSubTypeList: any = [];

  uiModel: any = {};

  constructor(public excRest: ExcRestService,
              public modal: ExgModalService,
              public enumSvc: EnumerationService) {
    super();
    const SELF = this;
    SELF.uiModel = {
      vorg_auID: '',
      //default values
      vorg_enmIdent_VorgangTyp: SELF.enumSvc.getEnumerationDefaultValue('VorgangTyp'),
      vorg_enmIdent_VorgangSubTyp: 0,
      vorg_enmIdent_VorgangStatus: 0,
      vorg_oid_Bearbeiter: '',
      vorgBeschreibung: '',
      vorgFrist: null,
      vorgBearbeiterCo_oeID: ''
    };
  }

  ngOnInit(): void {
    const SELF = this;
    SELF.uiModel.vorg_auID = SELF.data.auID;
    SELF.enumSvc.getEnumerationText('VorgangTyp',SELF.uiModel.vorg_enmIdent_VorgangTyp)
    //SELF.setTaskStatusIdent();
    SELF.getTaskTypeText();
    SELF.setTaskTypeIdent();
    SELF.getTaskSubTypeText();
  }

  getTaskTypeText(): void {
    const SELF = this;
    for (var index of SELF.taskTypeList) {
      SELF.taskTypeText.push(index.enmText);
    }
  }

  setTaskTypeIdent(): void {
    const SELF = this;
    for (var index of SELF.taskTypeList) {
      SELF.taskTypeIdent.push(index.enmIdent);
    }
  }

  /*setTaskStatusIdent(): void {
    const SELF = this;
    for (var index of SELF.taskStatusList) {
      SELF.taskStatusIdent.push(index.enmIdent);
    }
  }*/

  getTaskSubTypeText(): void {
    const SELF = this;
    SELF.taskSubTypeText = [];
    const item = SELF.enumSvc.getEnumerationList('VorgangTyp').find((e) => {
      return e.enmSelector;
    })

    SELF.taskSubTypeList = this.enumSvc.getEnumerationList(item.enmSelector);
    for (var index of SELF.taskSubTypeList) {
      SELF.taskSubTypeText.push(index.enmText);
    }
  }

  setTaskType($event: any): void {
    const SELF = this;
    console.log($event);
    console.log(SELF.enumSvc.getEnumerationList('VorgangTyp'));
    SELF.uiModel.vorg_enmIdent_VorgangTyp = SELF.enumSvc.getEnumerationList('VorgangTyp')[$event].enmIdent;
    SELF.taskTypeIndex = $event;
    console.log(SELF.uiModel);
    //here we list the taskSubType again bc we changed the taskType
   /* SELF.taskSubTypeText = [];
    SELF.taskSubTypeList = this.enumSvc.getEnumerationList(SELF.taskTypeList[$event].enmSelector);
    SELF.uiModel.vorg_enmIdent_VorgangSubTyp = SELF.enumSvc.getEnumerationDefaultValue(SELF.taskTypeList[$event].enmSelector)

    for (var index of SELF.taskSubTypeList) {
      SELF.taskSubTypeText.push(index.enmText);
    }*/
  }

  setTaskSubType($event: any): void {
    const SELF = this;
  }

  createNewTask(): void {
    const SELF = this;
    SELF.excRest.post(SELF.excRest.computeUrl('TaskC'), SELF.uiModel).subscribe((response: any) => {
      if (response.rtval) {
        this.modal.showToast(SELF.getTranslation('ModalTaskWorklist.Success'), 'md-toast', 'fas fa-check-circle');
        this.modal.action(true);
      } else {
        this.modal.showToast(SELF.getTranslation('ModalTaskWorklist.Fail'), 'md-toast', 'fas fa-exclamation');
      }
    });
  }

}
